import script from "./epinio.vue?vue&type=script&setup=true&lang=ts"
export * from "./epinio.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__